/// <amd-module name="Build/Common/Commands/permissions/Command.types" />
import { DefinitionReference } from "Build/Client/Contracts/Build";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssComponentProperties } from "VSS/Platform/Layout";

export interface IPermissionsProps extends IVssComponentProperties {
    definition?: DefinitionReference;
    path?: string;
}
